import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { calculateMonatssoll } from '@/domain/mitarbeiter/features/anlageassistent/utils/calculateMonatssoll';
import { Monate } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/monate';
import { cn } from '@/lib/utils';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function BerechnetesMonatssoll() {
  const { t } = useTranslation();
  const currentYear = dayjs().year();

  const form = useAnlageassistentFormContext();
  const calculatedMonatssoll = useMemo(
    () =>
      calculateMonatssoll({
        tagessoll:
          form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger
            .tagessoll ?? '00:00',
        tage:
          form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger
            .arbeitstage ?? [],
      }),
    [
      form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger.tagessoll,
      form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger
        .arbeitstage,
    ],
  );

  return (
    <div className="flex flex-col gap-4">
      <span className="text-neutrals-900 text-base font-bold leading-6">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnetesMonatssoll.label',
          { year: currentYear },
        )}
      </span>
      <div className="flex gap-2 justify-start h-full overflow-x-auto">
        {calculatedMonatssoll.map(({ monat, soll }) => (
          <MonatSoll
            key={monat.toString()}
            monat={monat}
            soll={soll}
            className="not-last:border-r not-last:border-neutrals-300 not-last:pr-4"
          />
        ))}
      </div>
    </div>
  );
}

function MonatSoll({
  monat,
  soll,
  className,
}: {
  monat: Monate[keyof Monate];
  soll: string;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <span className="text-neutrals-700 text-xs font-semibold leading-4">
        {t(`general.date.monthsShort.${monat}`)}
      </span>
      <span className="text-neutrals-900 text-sm font-semibold leading-5">
        {soll}
      </span>
    </div>
  );
}
